import React from 'react';
import { useFeatures } from 'flagged';
import ShowForViews from '@/components/common/ShowForViews';
import AuthRoutes from '@/constants/routing/AuthRoutes';
import FeatureFlags from '@/constants/system/FeatureFlags';
import UserViewEnums from '@/constants/users/UserViewEnums';
import translate from '@/lib/intl/translate';
import NavigationListItem from './NavigationListItem';

const {
  ADMIN,
  LANDING,
  BOARDS,
  CAMPAIGNS,
  REPORTS,
  COMPANY,
  INTEGRATIONS,
  CONSTITUENTS,
  OPPORTUNITIES,
  TASKS,
} = AuthRoutes;

const NavItems = [
  {
    navRoute: LANDING,
    exact: true,
    itemText: translate('HOME_NAV_LABEL'),
    name: 'home',
  },
  {
    navRoute: BOARDS,
    itemText: translate('LIFECYCLE_BOARDS'),
    name: 'lifecycleBoards',
  },
  {
    navRoute: OPPORTUNITIES,
    featureFlag: FeatureFlags.OPPORTUNITIES_MILESTONE_1,
    itemText: translate('OPPORTUNITIES_NAV_LABEL'),
    name: 'opportunities',
  },
  {
    navRoute: CONSTITUENTS,
    itemText: translate('CONSTITUENTS_NAV_LABEL'),
    name: 'constituents',
  },
  {
    navRoute: CAMPAIGNS,
    itemText: translate('CAMPAIGNS_NAV_LABEL'),
    name: 'campaigns',
  },
  {
    navRoute: REPORTS,
    itemText: translate('REPORTS_NAV_LABEL'),
    name: 'reports',
  },
  {
    navRoute: TASKS,
    itemText: translate('TASKS_NAV_LABEL'),
    name: 'tasks',
  },
  {
    navRoute: INTEGRATIONS,
    itemText: translate('INTEGRATIONS_NAV_LABEL_NEW'),
    name: 'integrations',
  },
  {
    navRoute: COMPANY,
    itemText: translate('SETTINGS_LABEL'),
    showFor: [UserViewEnums.ADMIN],
    name: 'company',
  },
  {
    navRoute: ADMIN,
    itemText: translate('SUPER_ADMIN_NAV_LABEL_NEW'),
    showFor: [UserViewEnums.SUPER_ADMIN],
    name: 'admin',
  },
];

const NavigationList = () => {
  return NavItems.map(({ featureFlag, showFor, ...item }) => {
    const { navRoute } = item;
    const features = useFeatures();

    let navItem = (
      <NavigationListItem
        {...{
          key: navRoute,
          ...item,
        }}
      />
    );

    if (featureFlag) {
      navItem = features[featureFlag] ? navItem : null;
    }

    if (showFor) {
      navItem = (
        <ShowForViews key={navRoute} showFor={showFor}>
          {navItem}
        </ShowForViews>
      );
    }

    return navItem;
  }).filter(Boolean);
};

export default NavigationList;
